import React, { useState, useEffect } from "react";

const CustomAlert = ({ message, type, onClose, duration = 3000 }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setIsVisible(true); // Show the alert when a message is present
      const timer = setTimeout(() => {
        setIsVisible(false); // Hide the alert after the duration
        onClose();
      }, duration);

      return () => clearTimeout(timer); // Cleanup the timer on component unmount or message change
    }
  }, [message, duration, onClose]); // Add dependencies to re-run effect when they change

  if (!message || !isVisible) return null;

  const alertClasses = {
    success: "bg-green-500 text-white",
    error: "bg-red-500 text-white",
    info: "bg-blue-500 text-white",
    warning: "bg-yellow-500 text-black",
  };  

  return (
    <div
      className={`fixed top-5 right-5 max-w-sm w-full p-4 rounded-lg shadow-lg flex items-center space-x-4 ${alertClasses[type]}`}
      style={{ zIndex: 9999 }}
    >
      <span className="flex-1">{message}</span>
      <button
        onClick={() => {
          setIsVisible(false); // Allow manual close
          onClose();
        }}
        className="text-2xl font-bold leading-none text-white"
      >
        &times;
      </button>
    </div>
  );
};

export default CustomAlert;
